import React, { MouseEvent, PropsWithChildren } from 'react';

import Link, { Props as LinkProps } from 'ds/Link';
import { CELL_PADDING, TABLE_CELL_FONT_SIZE } from 'ds/Table/constants';

import Layout from '../Layout';
import Text from '../Text';

interface Props extends Pick<LinkProps, 'href' | 'target' | 'onClick' | 'semibold' | 'color'> {
  text?: string;
  wrap?: boolean;
  /** When true (default when href is set), click does not bubble so row-level navigation is not triggered. */
  stopPropagation?: boolean;
  padding?: number;
}

const LinkCell: React.FC<PropsWithChildren<Props>> = ({
  href,
  text,
  target,
  onClick,
  children,
  semibold,
  wrap,
  stopPropagation = !!href,
  color = 'gray-900',
  padding = CELL_PADDING
}) => {
  const handleClick = (e: MouseEvent<HTMLLinkElement, MouseEvent>) => {
    if (stopPropagation) e.stopPropagation();
    onClick?.(e);
  };
  return (
    <Link href={href} target={target} opacity={false} onClick={handleClick} fullWidth fullHeight color={color}>
      <Layout padding={padding} height="100%" flexGrow={1} inline align="center">
        {text ? (
          <Text inline size={TABLE_CELL_FONT_SIZE} ellipsis semibold={semibold} color={color} wrap={wrap}>
            {text}
          </Text>
        ) : (
          children
        )}
      </Layout>
    </Link>
  );
};

export default LinkCell;
